export default __webpack_public_path__ + "static/jp1-3dfba265ad8f8b6e4652e6e09a5f14a4.png";